import { useQuery } from "react-query";
import { getSubmittedInvoices } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetSubmittedInvoices = () => {
  return useQuery("GetSubmittedInvoices", getSubmittedInvoices, {
    refetchOnWindowFocus: false,
  });
};
